import config from "../envVariable.config";

export const UrlsAi = config.phaseAi;
export const ValyriaEndpoints = config.phaseAi2;
export const _config = config;
